module.exports = __webpack_public_path__ + "img/arrow_large_painted.49987f2f.svg";